import { render } from "./VnTerm.vue?vue&type=template&id=516313c1&scoped=true"
import script from "./VnTerm.vue?vue&type=script&scoped=true&lang=js"
export * from "./VnTerm.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=516313c1&scoped=true&lang=css"
import "./VnTerm.vue?vue&type=style&index=1&id=516313c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-516313c1"

export default script